(() => {
  const shadowRoots = [];

  document.addEventListener('animationend', (e) => {
    if (e.animationName !== 'swinger-dummy-shadow-host') {
      return;
    }

    const target = window.swinger.eventHub.getTarget(e);

    console.log('Found a new Shadow Host:', target);

    shadowRoots.push(target);
  }, true);

  window.swinger = {
    ...window.swinger,
    $(selector, elem) {
      elem = elem || document;

      // const shadowRoots = [];
      //
      // if (HTMLElement.prototype.attachShadow) {
      //   const allElemsList = elem.getElementsByTagName('*');
      //   const allElemsListLength = allElemsList.length;
      //   let i = 0;
      //
      //   for (; i < allElemsListLength; i += 1) {
      //     if (allElemsList[i].shadowRoot) {
      //       shadowRoots.push(allElemsList[i].shadowRoot);
      //     }
      //   }
      // }

      try {
        // Safeguards against invalid selector
        elem.querySelectorAll(selector);
      } catch (e) {
        return [];
      }

      const nodeArray = [];
      const nodeList = elem.querySelectorAll(selector);
      const nodeListLength = nodeList.length;
      let i = 0;

      for (; i < nodeListLength; i += 1) {
        nodeArray.push(nodeList[i]);
      }

      const shadowRootsLength = shadowRoots.length;
      let j = 0;
      for (; j < shadowRootsLength; j += 1) {
        const nodeList = shadowRoots[j].querySelectorAll(selector);
        const nodeListLength = nodeList.length;
        let i = 0;

        for (; i < nodeListLength; i += 1) {
          nodeArray.push(nodeList[i]);
        }
      }

      return nodeArray;
    },
  };
})();
